import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Components
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
} from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import { Typography } from '@mui/material';

//Actions
import {
    pmUserForceLogoutOpenModal,
    pmUserForceLogoutRequest,
    clearRedux,
} from 'Redux/actions';

const ForceLogout = (props) => {
    const dispatch = useDispatch();

    const { messages } = useIntl();

    const { openModal, result, user, loading } = useSelector(state => state.forceLogoutRedux);

    const closeModal = () => {
        dispatch(pmUserForceLogoutOpenModal(false));
        dispatch(clearRedux("PMUSERS_FORCE_LOGOUT"))
    }

    const forceLogoutRequest = () => {
        let payload = {
            authId: `PM_${user.id}`,
            payload: JSON.stringify({ type: "LOGOUT" })
        }
        dispatch(pmUserForceLogoutRequest(payload));
    }

    useEffect(() => {
        if (result !== null) {
            if (result) {
                NotificationManager.success(
                    messages['pmusers_main_logged_out'],
                    messages['pmusers_main_force_logout'],
                    3000
                );
                closeModal();
            } else {
                NotificationManager.error(
                    messages['pmusers_main_not_logged_out'],   
                    messages['pmusers_main_force_logout'],
                    3000
                );
            }
            dispatch(clearRedux("PMUSERS_FORCE_LOGOUT", { result: null }))
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={`${messages['pmusers_main_force_logout']} ${user?.username ? `(${user?.username})` : ''}`}
            size="small"
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <Typography
                        variant="subtitle2"
                        color="textSecondary"
                    >
                        {messages['pmusers_main_do_you_want_to_force_user_logout']}
                    </Typography>
                </div>
            </ModalBody>
            <ModalFooter>
                <div>
                    <Button
                        className="btn btn-cancel"
                        onClick={(e) => closeModal()}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        className="btn-dark-blue"
                        onClick={(e) => forceLogoutRequest()}
                    >
                        {messages['pmusers_main_logout']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}
export default ForceLogout;